export const TIPO_VENDEDOR_LABELS = {
  INTERNO: "Interno",
  EXTERNO: "Externo"
};

export const TIPO_VENDEDOR_FILTER_OPTIONS = [
  { text: "Interno", value: "INTERNO" },
  { text: "Externo", value: "EXTERNO" },
  { text: "Sem tipo", value: "__SEM_TIPO__" }
];

export const VINCULO_FILTER_OPTIONS = [
  { text: "Todos", value: "TODOS" },
  { text: "Vinculados ao perfil", value: "VINCULADOS" },
  { text: "Não vinculados", value: "NAO_VINCULADOS" }
];

export const ATIVO_FILTER_OPTIONS = [
  { text: "Ativos", value: "true" },
  { text: "Inativos", value: "false" }
];

export const PERFIL_STATUS_FILTER_OPTIONS = [
  { text: "Ativos", value: "true" },
  { text: "Inativos", value: "false" }
];

export const formatTipoVendedor = tipo => {
  if (!tipo) return "—";
  const key = String(tipo)
    .trim()
    .toUpperCase();
  return TIPO_VENDEDOR_LABELS[key] || tipo;
};

export const tipoVendedorChipColor = tipo => {
  const key = String(tipo || "")
    .trim()
    .toUpperCase();
  if (key === "EXTERNO") return "orange";
  if (key === "INTERNO") return "cyan";
  return "grey";
};
